var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8334 2.5C8.92961 2.5 3.33336 8.09625 3.33336 15C3.33336 21.9037 8.92961 27.5 15.8334 27.5C22.7371 27.5 28.3334 21.9037 28.3334 15C28.3334 8.09625 22.7371 2.5 15.8334 2.5ZM16.4584 21.25H15.2084C14.8634 21.25 14.5834 20.97 14.5834 20.625V19.375C14.5834 19.03 14.8634 18.75 15.2084 18.75H16.4584C16.8034 18.75 17.0834 19.03 17.0834 19.375V20.625C17.0834 20.97 16.8034 21.25 16.4584 21.25ZM15.8334 16.25C15.1434 16.25 14.5834 15.69 14.5834 15V10C14.5834 9.31 15.1434 8.75 15.8334 8.75C16.5234 8.75 17.0834 9.31 17.0834 10V15C17.0834 15.69 16.5234 16.25 15.8334 16.25Z",
    fill: "#FF5853"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.317ec2360b2428c2d4ba035f84986ecc.svg";
export { ForwardRef as ReactComponent };